import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/reddit': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248s-248-111-248-248 111-248 248-248 248 111 248 248zM371.7 214.8c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9 0-13.6-11.1-24.9-24.9-24.9-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-0.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-0.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c2.2-2.2 6.1-2.2 8.3 0 2.5 2.5 2.5 6.4 0 8.6-22.9 22.8-87.4 22.8-110.2 0-2.5-2.2-2.5-6.1 0-8.6 2.2-2.2 6.1-2.2 8.3 0 17.5 17.9 75.4 18.2 93.6 0zM310.5 256c13.9 0 24.9 11.1 24.9 24.9 0 13.5-11.1 24.6-24.9 24.6-13.5 0-24.6-11-24.6-24.6 0-13.8 11-24.9 24.6-24.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/reddit.js
// module id = 990
// module chunks = 0